import React from "react";
import tools from "../../../helpers/tools";

const PhoneLink = ({ phone }) => {
  return <a href={`tel:${phone}`}>{tools.formatPhone(phone)}</a>;
};

export default PhoneLink;
